<template>
    <div class="chart-font">
        <div class="row">
            <div class="col title text-muted">{{ title }}</div>
            <div class="col-md-auto"><a :href="hrefMore">More...</a></div>
        </div>
        <div v-if="documents.length" class="table-responsive">
            <table class="table table-sm">
                <thead>
                    <th></th>
                    <th>Number</th>
                    <th>Patient</th>
                    <th>Description</th>
                    <th>Payer</th>
                    <th>Status</th>
                    <th class="text-center">Days Remaining</th>
                </thead>
                <tbody>
                    <tr v-for="document in documents" :key="document.id">
                        <td class="fit"><i v-if="document.attention" class="fas fa-exclamation-triangle text-warning" :title="message(document.days_remaining)"></i></td>
                        <td><a :href="'/claims/' + document.claim_id" v-text="document.claim_number"></a></td>
                        <td><a :href="'/claims/' + document.claim_id" v-text="document.patient_name"></a></td>
                        <td :title="document.description">{{ document.description | truncate(10) }}</td>
                        <td v-text="document.payer_name"></td>
                        <td v-text="document.document_status_name"></td>
                        <td class="text-center">{{ document.days_remaining }}</td>              
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-else class="border-top pt-2">
            <h5 class="text-muted text-center">No {{ title }}</h5>
        </div> 
    </div>    
</template>

<script>
export default {
    props: {
        title: String,
        href: String
    },
    data() {
        return {
            documents: []
        }
    },
    computed: {
        hrefMore: function () {
            return this.href.replace('dashboard/disputable/documents', 'reports/disputable-authorization-documents');
        }
    },
    methods: {
        message: function (days) {
            return 'Only ' + days + ' days remaining to dispute.';
        }
    },
    mounted() {
        axios.get(this.href)
            .then(response => {
                this.documents = response.data;
            });
    }    
}
</script>

<style scoped>
    .chart-font {
        font-size: 12px;
        font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
        font-style: normal;
        font-weight: bold;
        color: #666;
    }

    .fa-exclamation-triangle.text-warning {
        background:linear-gradient(#555,#555) center bottom/20% 84% no-repeat;
        font-size: 1.25em;
    } 
</style>